import React, { useState, useCallback} from "react";
import { Link, useNavigate } from "react-router-dom";

import _, { debounce } from "lodash";
import userSearchIcon from "../../assests/search-icon.png";
import { AiOutlinePieChart } from "react-icons/ai";
import { IoPersonAddOutline } from "react-icons/io5";
import { FiUserPlus } from "react-icons/fi";
import { FiUserMinus } from "react-icons/fi";

import { IoPersonAddSharp } from "react-icons/io5";
import { FaChartPie } from "react-icons/fa";
import { BsBookmarkPlusFill } from "react-icons/bs";
import { MdOutlinePlaylistRemove } from "react-icons/md";

import { CiBookmarkPlus } from "react-icons/ci";
import RecallIcon from "../../assests/recallIcon.svg";
import ViewRecalledEpisodes from "../../assests/viewrecalledepisodes.svg";
import { Spinner } from "../../common/Helper";
import { toast, ToastContainer } from "react-toastify";
import { MdHideImage } from "react-icons/md";
import InfiniteScroll from "../../../codercompanion/components/infinite-scroll";
import {
  getauditData,
  getAuditFiles,
  getAuditRows,
  getAuditRowsByFileName,
  getSearchData,
  getSearchRecommendations,
  recall_episode,
  getUsers,
  episodeAssignedUsers,
  flag_and_unflag,
  episodeUnAssignedUsers,
  fetchUnassignedEpisodes
} from "../../api/Service";
import { Button, Dropdown, Form } from "react-bootstrap";
import assgineTickIcon from "../../assests/assgine-tick.png";
import AssignedToModal from "../filters/AssignedToModal";
import "./Sidenavbar.css";

export default function SidenavbarTemp({
  mode,
  setMode,
  updatedAuditRows,
  handleRefreshClick,
  setAuditDetails,
  setIsRowsLoading,
  isRowsLoading,
  getAuditRowsByFilter,
  appliedFilters,
  setAppliedFilters,
  setHasMore,
  setAuditRows,
  setflagAuditRows,
  flagauditRows,
  getAuditRowsData,
  setPage,
  editFlageData,
  selectedEpisodeRows,
  setSelectedEpisodeRows,
  isAllEpisodesSelected,
  setIsAllEpisodesSelected,
  recall_page,
  setRecall_page,
  searchEpisodeIdentifier,
  setSearchEpisodeIdentifier,
  recommendations,
  setRecommendations,
  selectAllFiles,
  setSelectAllFiles,
  selectedColumns,
  toggleColumnSelection,
  isAssigned,
  setIsAssigned,
  unassined_page,
  setUnassined_page,
  addUnassignReason,
  setAddUnassignReason
}) {
  const [openUserAssgineeModal, setOpenUserAssgineeModal] = useState(false);
  const [selectedAssgineeUser, setSelectedAssgineeUser] = useState(null);
  const [hasMoreUsers, setHasMoreUsers] = useState(true);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [searchAssgineeUserName, setSearchAssgineeUserName] = useState("");
  const [assgineCurrentPage, setAssgineCurrentPage] = useState(1);
  const [getAllUsers, setGetAllUsers] = useState([]);
  const [openConfirmAssgineModal, setOpenConfirmAssgineModal] = useState(false);
  const [isAssigneLoading, setIsAssigneLoading] = useState(false);
  const [isUnassignLoading,setIsUnassignLoading] = useState(false)
  const assginedUserId = JSON.parse(sessionStorage.getItem("userId"));
  const [addAssignReason, setAddAssignReason] = useState("");
  const [filtersObj, setFiltersObj] = useState({ ...appliedFilters });
  const [showColumnsDropdown, setShowColumnsDropdown] = useState(false);
  const [openConfirmUnAssgineModal, setOpenConfirmUnAssgineModal] = useState(false);
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  const admin = permissions?.admin || false;
   const navigate = useNavigate();
   const showUnassignLoadingText =()=>{
    return(<div className="loading-assigne-modal-overlay-fade z-3">
      <div className="loading-modal-content-section">
        <p>Unassigning is in progress, Please wait...</p>
        <Spinner />
      </div>
    </div>)
    
   }
  const showLoadingText = () => {
    return (
      <div className="loading-assigne-modal-overlay-fade z-3">
        <div className="loading-modal-content-section">
          <p>Assigning is in progress, Please wait...</p>
          <Spinner />
        </div>
      </div>
    );
  };
  const cancelAssignReason = () => {
    setOpenConfirmAssgineModal(false);
  };
    const episodeUnassgineHandler = () => {
      if(selectedEpisodeRows && selectedEpisodeRows?.length > 0){
        setOpenConfirmUnAssgineModal(true);
      }else{
        toast.info("Please Select Some Episodes")
      }
    }
   const callAPI = () => {
     episodeUnAssignedUsers(selectedEpisodeRows, assginedUserId, addUnassignReason, isAllEpisodesSelected, appliedFilters, !recall_page,appliedFilters.header_id)
       .then((res)=>{
         toast.success(res.message ? res.message : "Episodes are unassigned and e-mail has been sent successfully");
         setTimeout(()=>{
          window.location.reload()
         },3000)
         
         setOpenConfirmUnAssgineModal(false);
       })
       .catch((err)=>{
         toast.error("Episode unassigned failed");
         setOpenConfirmUnAssgineModal(true);
         console.log("Episode unassigned failed::", err.message)
       })
       .finally(()=>{setIsUnassignLoading(false)})
   }   
  const fetchUsers = useCallback(
    debounce((userName) => {
      setLoadingUsers(true);
      setHasMoreUsers(true);
      getUsers(userName, assgineCurrentPage)
        .then((res) => {
          if (res.message) {
            toast.error(res.message);
          }
          const { users } = res.data;
          setGetAllUsers(users);
        })
        .catch((err) => {
          console.log("No Users Found::", err.message);
          // setNoUsersMessage(err.message)
          setGetAllUsers([]);
        })
        .finally(() => setLoadingUsers(false));
    }, 500),
    []
  );
  const handleAssignReason = () => {
    setOpenConfirmAssgineModal(!openConfirmAssgineModal);
    episodeUserAssignments();
  };
  const episodeUserAssignments = useCallback(() => {
    setIsAssigneLoading(true);
    episodeAssignedUsers(
      selectedEpisodeRows,
      selectedAssgineeUser?.user_id,
      assginedUserId,
      addAssignReason,
      isAllEpisodesSelected,
      appliedFilters,
      recall_page,
      appliedFilters.header_id,
      unassined_page
    )
      .then((repo) => {
        if (repo?.response?.status === 401) {
          const errMessage = repo?.response?.data?.message.includes(
            "TypeError: Cannot read properties of undefined"
          )
            ? "Assign failed"
            : repo?.response?.data?.message || "An unknown error occurred";
          toast.error(errMessage);
          console.log(
            "Episode assigned failed::",
            repo?.response?.data?.message
          );
          setGetAllUsers([]);
          setSearchAssgineeUserName("");
          setSelectedAssgineeUser(null);
          setAssgineCurrentPage(1);
        } else {
          toast.success(repo.message);
          setSelectedEpisodeRows([]);
          setIsAllEpisodesSelected(false);
          window.location.reload();
          setHasMoreUsers(true);
        }
      })
      .catch((err) => {
        const errMessage = err.message.includes("Cannot read properties")
          ? "Assign failed"
          : err.message;
        toast.error("Episodes Assignement Failed");
        console.log("Episode assigned failed::", err.message);
        setGetAllUsers([]);
        setSearchAssgineeUserName("");
        setSelectedAssgineeUser(null);
        setAssgineCurrentPage(1);
      })
      .finally(() => setIsAssigneLoading(false));
  }, [
    selectedEpisodeRows,
    selectedAssgineeUser,
    assginedUserId,
    addAssignReason,
    isAllEpisodesSelected,
    filtersObj,
  ]);
  const assgineeModalHandle = (e) => {
    setOpenUserAssgineeModal((prev) => {
      const modalIsOpened = !prev;
      if (modalIsOpened) {
        setHasMoreUsers(true);
        setLoadingUsers(true);
        getUsers(searchAssgineeUserName, assgineCurrentPage)
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            }
            const { users } = res.data;
            setGetAllUsers(users);
          })
          .catch((err) => {
            console.log("No Users Found::", err.message);
          })
          .finally(() => setLoadingUsers(false));
      } else {
        setGetAllUsers([]);
        setSearchAssgineeUserName("");
        setSelectedAssgineeUser(null);
        setAssgineCurrentPage(1);
      }
      return modalIsOpened;
    });
  };
  const searchAssgineUsers = (event) => {
    const { value } = event.target;
    setSearchAssgineeUserName(value);
    fetchUsers(value);
  };
  const getMoreUsers = async (assgineCurrentPage, load_more) => {
    try {
      setLoadingUsers(true);
      const response = await getUsers(
        searchAssgineeUserName,
        assgineCurrentPage
      );
      const { users } = response.data;
      const mergedUsers = [
        ...new Map(
          [...getAllUsers, ...users].map((item) => [item.user_id, item])
        ).values(),
      ];
      if (load_more) {
        setGetAllUsers(mergedUsers);
      } else {
        setGetAllUsers(users);
      }
      setHasMoreUsers(true);
      const newPage = assgineCurrentPage + 1;
      setAssgineCurrentPage(newPage);
    } catch (error) {
      console.log("Error fetching users:", error);
      setHasMoreUsers(false);
      setAssgineCurrentPage(1);
      if (!load_more) {
        setGetAllUsers([]);
      }
    } finally {
      setLoadingUsers(false);
    }
  };
  const handleAssgintoUsers = (data) => {
    if (selectedEpisodeRows && !selectedEpisodeRows?.length > 0) {
      toast.info("Please Select Some Episodes");
    }
    if (selectedEpisodeRows && selectedEpisodeRows?.length > 0) {
      if (selectedAssgineeUser?.user_id === data?.user_id) {
        return;
      }
      setSelectedAssgineeUser(data);
    }
  };
  const assginToHandler = (e) => {
    if (selectedEpisodeRows && !selectedEpisodeRows.length > 0) {
      toast.info("Please Select Some Episodes");
    } else {
      if (selectedAssgineeUser === null) {
        toast.info("Please Select User");
      } else {
        setOpenUserAssgineeModal(false);
        setOpenConfirmAssgineModal(true);
        setSearchAssgineeUserName("");
      }
    }
  };
    const getUnassignedEpisodes = ()=>{
      console.log(assginedUserId,"assigned by")
      fetchUnassignedEpisodes( assginedUserId, filtersObj, !recall_page,appliedFilters.header_id)
    .then((res)=>{
      // toast.success(res.message ? res.message : "Episodes are unassigned and e-mail has been sent successfully");
      // window.location.reload()
      // console.log(res?.unassigned_episodes);
      setAuditRows(res?.unassigned_episodes)
    })
    .catch((err)=>{
  
      toast.error("No Data");
      
      console.log("Episode unassigned failed::", err.message)
    })
  }
  const handleFlagUnFlag = () => {
    console.log(appliedFilters.header_id, "newobj");
    if (selectedEpisodeRows && !selectedEpisodeRows?.length > 0) {
      toast.info("Please Select Some Episodes");
    } else if (!flagauditRows) {
      flag_and_unflag(
        selectedEpisodeRows,
        selectedAssgineeUser?.user_id,
        assginedUserId,
        addAssignReason,
        isAllEpisodesSelected,
        filtersObj,
        !recall_page,
        appliedFilters.header_id
      )
        .then((res) => {
          // toast.success(res.data.message);
          window.location.reload();
        })
        .catch((err) => {
          toast.error(err.message);
          console.log("Episode assigned failed::", err.message);
        });
    } else {
      flag_and_unflag(
        selectedEpisodeRows,
        selectedAssgineeUser?.user_id,
        assginedUserId,
        addAssignReason,
        isAllEpisodesSelected,
        filtersObj,
        !recall_page,
        appliedFilters.header_id
      )
        .then((res) => {
          //toast.success(res.data.message);
          window.location.reload();
        })
        .catch((err) => {
          toast.error(err.message);
          console.log("Episode assigned failed::", err.message);
        });
    }
  };
  return (
    <div className="side-navbar-component">
      <div className="side-navbar-item" onClick={() =>navigate("/workflow-dashboard")}>
        <AiOutlinePieChart style={{  }} />
        <span>Dashboard</span>
      </div>

      <div className="side-navbar-item dropdown-navbar-item">
        <Dropdown
          className="dropdown-assgine"
          show={openUserAssgineeModal}
          onToggle={assgineeModalHandle}
          autoClose="outside"
        >
          <Dropdown.Toggle
            style={{
              backgroundColor: "transparent !important",
              border: "none !important",
              height: "25px",
              boxShadow: "none !important",
            }}
            className={`dropdown-toggle-header ${
              openUserAssgineeModal ? "open" : "close"
            }`}
          >
            <FiUserPlus  />
            <span>Assign</span>
          </Dropdown.Toggle>
          <Dropdown.Menu className="assgine-modal-section">
            <Dropdown.Item
              eventKey={openUserAssgineeModal}
              className="assgine-dropdown-item"
            >
              <div className="assigne-search-section">
                <img
                  className="assigne-search-icon"
                  src={userSearchIcon}
                  alt={"userSearchIcon"}
                />
                <input
                  className="assgine-search-input"
                  type="text"
                  value={searchAssgineeUserName}
                  onChange={searchAssgineUsers}
                  placeholder="Search by Username or Email"
                />
              </div>
              <InfiniteScroll
                className="assgine-modal-body"
                hasData={hasMoreUsers}
                loadMore={() => getMoreUsers(assgineCurrentPage, true)}
                isLoading={loadingUsers}
              >
                {getAllUsers && getAllUsers?.length > 0
                  ? getAllUsers?.map((user, index) => {
                      return (
                        <div
                          className={`assigne-user-section ${
                            selectedAssgineeUser?.user_id === user?.user_id
                              ? " active"
                              : ""
                          }`}
                          onClick={() => handleAssgintoUsers(user)}
                        >
                          <div className="assigne-card">
                            <p>
                              <span className="assgine-user-name-icon">
                                {user?.username ? user?.username[0] : ""}
                              </span>
                            </p>
                            <p className="assigne-user-email-card">
                              <span className="assign-username">
                                {user?.username
                                  ? user?.username
                                  : "User not found"}
                              </span>
                              <span className="assign-email">
                                {user?.email ? user?.email : ""}
                              </span>
                            </p>
                          </div>
                          <div className="">
                            {selectedAssgineeUser?.user_id === user?.user_id ? (
                              <img src={assgineTickIcon} alt="" />
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      );
                    })
                  : !loadingUsers && (
                      <p className="no-usersfound">No Users Found</p>
                    )}
              </InfiniteScroll>
              <div className="assgine-actions-btn">
                <button className="assigne-save-btn" onClick={assginToHandler}>
                  Assign
                </button>
              </div>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        {isAssigneLoading && showLoadingText()}
        {openConfirmAssgineModal && (
          <AssignedToModal
            handleAssignReason={handleAssignReason}
            cancelAssignReason={cancelAssignReason}
            addAssignReason={addAssignReason}
            setAddAssignReason={setAddAssignReason}
          />
        )}
      </div>
      {/* unassign button */}
      {recall_page&&admin&&<div className="side-navbar-item " onClick={episodeUnassgineHandler}><FiUserMinus 
                          style={{
                            width: "20px",
                            height: "20px",
                            textAlign: "center",
                          }}  />
                            <span >UnAssign</span>
                          </div>}
       {!unassined_page&&!recall_page&&<div className="side-navbar-item " onClick={episodeUnassgineHandler}><FiUserMinus 
                          style={{
                            width: "20px",
                            height: "20px",
                            textAlign: "center",
                          }}  />
                            <span >Unassign</span>
                          </div>}
                          {isUnassignLoading && showUnassignLoadingText()}
                          {openConfirmUnAssgineModal && (
         <div className="unassign-reason-modal-overlay-fade z-3">
         <div className="unassign-reason-modal-content-section">
            <div className="unassign-reason-modal-content-header">
             <p>Add Specific Reason</p>
           </div>
           <div className="unassign-reason-modal-content-body">
           <div className="unassign-reason-textarea">
             <textarea 
               className="unassign-search-textarea"
               type="text"
               rows="4"
               value={addUnassignReason}
               onChange={(e) => setAddUnassignReason(e.target.value)}
               placeholder="Add the reason"/>
           </div>
           </div>
           <div className="unassign-reason-actions-btn">
             <button className="unassign-reason-btn-cancel" onClick={() => {
              setAddUnassignReason("")
              setOpenConfirmUnAssgineModal(false)
             }}>
               Cancel
             </button>
             <button className="unassign-reason-btn-save" onClick={() => {
              console.log("ram")
              setAddUnassignReason("")
              setOpenConfirmUnAssgineModal(false)
              console.log(isUnassignLoading,"ram")
              setIsUnassignLoading(true)
              callAPI()
             }}>
               Ok
             </button>
           </div>
         </div>
       </div>
      )}
                           {admin&&!isAssigned &&<div onClick={()=>{
                localStorage.removeItem("breadcrumbClick")
                setSearchEpisodeIdentifier("");
                setRecommendations([]);
                setflagAuditRows(false);
                setRecall_page(false);
                setIsAssigned(true);
                setUnassined_page(true);
                setIsAllEpisodesSelected(false);
                setSelectAllFiles(false)
                setFiltersObj({
                  fileType: [],
                  priorityValue: [],
                  status: [],
                  assigned_to: [],
                  assigned_by: [],
                  case_mix_speciality: [],
                  insurerIdentifier: [],
                  codedBy: [],
                  fromAdmissionDate: "",
                  toAdmissionDate: "",
                  fromSeparationDate: "",
                  toSeparationDate: "",
                  length_of_stay: [],
                })
                setAppliedFilters({
                  insurer_identifier: [],
                  priority_value: [],
                  episode_identifier:[],
                  status: [],
                  file_type: [],
                  header_id: [],
                  coder_name: [],
                  admission_date_from: "",
                  admission_date_to: "",
                  separation_date_from: "",
                  separation_date_to: "",
                  length_of_stay: [],
                  assigned_by:[],
                  assigned_to: [],
                  audit_ref_no:[],
                  uploaded_by_user_name : [],
                  hcp_line_updated_at : [],
                  short_description:[],
                  case_mix_speciality:[],
                  drg:[]
                });
                //sessionStorage.setItem("flagStatus",flagauditRows);
                // Clear existing rows and reset pagination
                //setIsRowsLoading(true);
                setAuditRows([]);
                setPage(1);
                setHasMore(true);
                getUnassignedEpisodes()
              }} className="side-navbar-item"><MdOutlinePlaylistRemove className="navbar-icon"/>
                <span className="">
                     Unassigned Episodes
                    </span>
              </div>}
     {!unassined_page&&<div className="side-navbar-item" onClick={handleFlagUnFlag}>
        <img
          src={RecallIcon}
          alt="Recall Icon"
          className="icon-style"
          style={{ width: "28px", height: "28px", color: "gray" }}
        />
        <span>{!flagauditRows ? "Recall" : "Reflag"}</span>
      </div>} 
      {!flagauditRows && (
        <div className="side-navbar-item">
          <img
            src={ViewRecalledEpisodes}
            alt="Recall Icon"
            className="icon-style"
            style={{ width: "28px", height: "28px", color: "gray" }}
          />
          {/* <span>Recalled Episodes</span> */}
          <span
            className=""
            onClick={() => {
              localStorage.removeItem("breadcrumbClick");
              //  setSearchEpisodeIdentifier("");
              setRecommendations([]);
              setflagAuditRows(true);
              setRecall_page(true);
              setIsAssigned(false);
              setUnassined_page(false);
              setIsAllEpisodesSelected(false);
              setSelectAllFiles(false);
              setFiltersObj({
                  fileType: [],
                  priorityValue: [],
                  status: [],
                  assigned_to: [],
                  assigned_by: [],
                  case_mix_speciality: [],
                  insurerIdentifier: [],
                  codedBy: [],
                  fromAdmissionDate: "",
                  toAdmissionDate: "",
                  fromSeparationDate: "",
                  toSeparationDate: "",
                  length_of_stay: [],
                })
                setAppliedFilters({
                  insurer_identifier: [],
                  priority_value: [],
                  episode_identifier:[],
                  status: [],
                  file_type: [],
                  header_id: [],
                  coder_name: [],
                  admission_date_from: "",
                  admission_date_to: "",
                  separation_date_from: "",
                  separation_date_to: "",
                  length_of_stay: [],
                  assigned_by:[],
                  assigned_to: [],
                  audit_ref_no:[],
                  uploaded_by_user_name : [],
                  hcp_line_updated_at : [],
                  short_description:[],
                  case_mix_speciality:[],
                  drg:[]
                });
              //sessionStorage.setItem("flagStatus",flagauditRows);
              // Clear existing rows and reset pagination
              //setIsRowsLoading(true);
              setAuditRows([]);
              setPage(1);
              setHasMore(true);

              // Fetch flagged rows
              // getAuditRowsData(1);
              recall_episode({ page_number: 1 })
                .then((res) => {
                  //console.log("auditRows Res",res);
                  if (res.data.message) {
                    toast.error(res.data.message);
                  }
                  //getAuditRows({});
                  // setAuditRows(res.res.audited_rows)
                  //setAuditRows(res.data.data.audited_rows); // Create a new array
                  // setflagAuditRows(true);
                })
                .catch((err) => {
                  console.log("Error: " + err.message);
                });
            }}
          >
            Recalled Episodes
          </span>
        </div>
      )}


      {/* {flagauditRows && (
        <div className="side-navbar-item">
          <div
            className="recall-btn"
            onClick={() => {
              window.location.reload();
              setRecall_page(false);
            }}
          >
            Back
          </div>
        </div>
      )} */}

      {/* <div className='side-navbar-item'>
      <MdHideImage style={{color:"#032F49"}}/>
      
       <span>Select Preferred Columnss</span>
      </div> */}
      <div className="side-navbar-item dropdown-navbar-item">
        <Dropdown
          show={showColumnsDropdown}
          // onToggle={() => setShowColumnsDropdown(!showColumnsDropdown)}
          onToggle={(isOpen, event) => {
            // Only toggle if the event is from the dropdown toggle or outside
            const isFromToggle =
              event?.currentTarget?.classList?.contains(
                "dropdown-toggle-header"
              ) || event?.target?.closest(".dropdown-toggle-header");
            const isFromOutside = !event?.target?.closest(
              ".columns-dropdown-menu"
            );

            if (isFromToggle || isFromOutside) {
              setShowColumnsDropdown(!showColumnsDropdown);
            }
          }}
          autoClose="outside"
        >
          <Dropdown.Toggle
            className="dropdown-toggle-header"
            style={{
              backgroundColor: "transparent !important",
              border: "none !important",
              height: "25px",
              boxShadow: "none !important",
            }}
          >
            <MdHideImage style={{ color: "#032F49" }} />
            <span>Select Preferred Columns</span>
          </Dropdown.Toggle>
          <Dropdown.Menu
            className="columns-dropdown-menu"
            style={{
              minWidth: "238px",
              maxHeight: "280px",
              overflowY: "scroll",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {selectedColumns.map((column) => (
              <Dropdown.Item key={column.id} className="column-item" as="div">
                <Form.Check
                  type="checkbox"
                  id={`column-${column.id}`}
                  label={column.label}
                  checked={column.checked}
                  // onChange={() => toggleColumnSelection(column.id)}
                  onChange={(e) => {
                    e.stopPropagation();
                    toggleColumnSelection(column.id);
                  }}
                  onClick={(e) => e.stopPropagation()}
                />
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
}
